module.exports = __webpack_public_path__ + "static/media/MHRP09N0003.97e2e9cb.svg";